import Vue from 'vue'
import Vuex from 'vuex'
import { menuItem_qy, login } from '@/api/home'
Vue.use(Vuex)
export default new Vuex.Store({
  modules: {

  },
  state: {
    menu: null,
    leftMenu: [],
    rightList: [],
    articleText: '',
    user: null

  },
  mutations: {
    SET_ARTICLETEXT: (state, articleText) => {
      state.articleText = articleText
    },
    SET_MENU: (state, menu) => {
      state.menu = menu
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_LEFTMENU: (state, leftMenu) => {
      state.leftMenu = leftMenu
    },
    SET_RIGHTLIST: (state, rightList) => {
      state.rightList = rightList
    },
  },
  actions: {
    setArticleText({ commit }, data) {
      commit('SET_ARTICLETEXT', data)
    },
    setMenu({ commit }, data) {
      commit('SET_MENU', data)
    },
    setLeftMenu({ commit }, data) {
      commit('SET_LEFTMENU', data)
    },
    setRightList({ commit }, data) {
      commit('SET_RIGHTLIST', data)
    },
    getMenu({ commit }, data) {
      return new Promise((resolve, reject) => {
        menuItem_qy(data).then(response => {
          commit('SET_MENU', response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUser({ commit }, data) {
      return new Promise((resolve, reject) => {
        login({ op: 'getSessionUser' }).then(response => {
          commit('SET_USER', response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    menu: state => state.menu,
    user: state => state.user,
  },
})
